import { useQuery } from '@apollo/client'
import React from 'react'
import {
  InsuranceReviewFilterInput,
  GetInsuranceReviewForVerification,
  GetInsuranceReviewForVerificationVariables,
} from '../../types'
import { GET_INSURANCE_REVIEW_FOR_VERIFICATION } from './operations'

interface Props {
  filter?: InsuranceReviewFilterInput
  page?: number
  pageLength?: number
}

const PAGE_LENGTH = 10

export const useInsuranceReviewForVerification = ({
  filter,
  page = 1,
  pageLength = PAGE_LENGTH,
}: Props) => {
  const { emailOrNameLike } = filter || {}
  const queryVariables = React.useMemo<GetInsuranceReviewForVerificationVariables>(
    () => ({
      filterData: {
        emailOrNameLike,
      },
      pagination: {
        from: pageLength * (page - 1) || 0,
        length: pageLength,
      },
    }),
    [emailOrNameLike, page, pageLength]
  )
  const insurances = useQuery<
    GetInsuranceReviewForVerification,
    GetInsuranceReviewForVerificationVariables
  >(GET_INSURANCE_REVIEW_FOR_VERIFICATION, {
    variables: queryVariables,
  })
  return insurances
}
